import React from "react";
import "../../common/loader.module.css";
import Footer from "../pageFooter/Footer";

interface PageLoaderProps {
  children?: any;
}

const PageLoader: React.FC<PageLoaderProps> = ({ children }): JSX.Element => {
  return (
    <React.Fragment>
      {children}
      <Footer />
    </React.Fragment>
  );
};

export default PageLoader;
